var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoInfopopDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 60,
    viewBox: "0 0 101 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1201_10622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 39.9981V12.8003C0 5.75675 5.75675 0 12.8003 0H43.2998V27.1978C43.2998 34.2357 37.543 39.9981 30.4995 39.9981H0Z",
    fill: "#4CB2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8001 4.79724C8.38659 4.79724 4.80273 8.38674 4.80273 12.7946V35.1951H30.4993C34.9071 35.1951 38.4966 31.6056 38.4966 27.1978V4.79724H12.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3467 30.0649H11.9819V17.3662H14.3467V30.0649V30.0649Z",
    fill: "#4CB2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1966 17.3662H30.5614V30.0649H26.6332L21.3901 19.4488H21.3054L21.503 30.0649H19.1382V17.3662H23.0494L28.3264 27.9823H28.3941L28.1966 17.3662Z",
    fill: "#4CB2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93009 49.113H0.0224609V59.8928H1.93009V49.113Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4009 57.6917L7.72064 49.113H5.32764V59.8872H7.22962V51.3085L15.9099 59.8872H18.3085V49.113H16.4009V57.6917Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 59.8872H23.5685V55.1915H31.3627V53.4983H23.5685V50.8062H31.6787V49.113H21.6665V59.8872Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7905 49.0001H38.0789C35.3699 49.0001 34.2637 50.191 34.2637 53.1032V55.8969C34.2637 58.8148 35.3699 60 38.0789 60H43.7905C46.4996 60 47.6058 58.8092 47.6058 55.8969V53.1032C47.6058 50.1853 46.4996 49.0001 43.7905 49.0001ZM45.6982 52.584V56.4218C45.6982 57.7651 45.1055 58.3125 43.6551 58.3125H38.22C36.7696 58.3125 36.1769 57.7651 36.1769 56.4218V52.584C36.1769 51.2407 36.7696 50.6933 38.22 50.6933H43.6551C45.1055 50.6933 45.6982 51.2407 45.6982 52.584Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1957 49.113H58.7524V59.8928H60.6601V55.8744H66.9361C70.0853 55.8744 70.3111 54.4804 70.3111 52.1777C70.3111 49.6266 69.1202 49.1187 67.1957 49.1187V49.113ZM60.6601 50.8062H66.8796C68.0366 50.8062 68.4035 51.1053 68.4035 52.0309V53.0017C68.4035 53.8313 67.9915 54.17 66.9869 54.17H60.6544V50.8006L60.6601 50.8062Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.248 49.0001H76.5364C73.8274 49.0001 72.7212 50.191 72.7212 53.1032V55.8969C72.7212 58.8148 73.8274 60 76.5364 60H82.248C84.9571 60 86.0633 58.8092 86.0633 55.8969V53.1032C86.0633 50.1853 84.9571 49.0001 82.248 49.0001ZM84.1557 52.584V56.4218C84.1557 57.7651 83.5631 58.3125 82.1126 58.3125H76.6775C75.2271 58.3125 74.6345 57.7651 74.6345 56.4218V52.584C74.6345 51.2407 75.2271 50.6933 76.6775 50.6933H82.1126C83.5631 50.6933 84.1557 51.2407 84.1557 52.584Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.684 49.113H89.2407V59.8928H91.1484V55.8744H97.4243C100.574 55.8744 100.799 54.4804 100.799 52.1777C100.799 49.6266 99.6085 49.1187 97.684 49.1187V49.113ZM91.1484 50.8062H97.3679C98.5249 50.8062 98.8917 51.1053 98.8917 52.0309V53.0017C98.8917 53.8313 98.4797 54.17 97.4751 54.17H91.1427V50.8006L91.1484 50.8062Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1201_10622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.8,
    height: 60,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInfopopDesktop);
export default __webpack_public_path__ + "static/media/logo_infopop_desktop.80b7ca3bdc500e2aedc351953d766ef0.svg";
export { ForwardRef as ReactComponent };